<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <div class="contenu pt-12">
                <span class="open-book">
                    <p class="text-2xl mb-10 leading-custom">
                        Dans le monde de
                        <span class="sunshiney">Quest Me</span>,
                        <br>découvrez qui vous entoure en avançant dans les niveaux.
                    </p>
                </span>
                <span class="open-book">
                    <p
                        class="text-2xl mb-10 leading-custom"
                    >Racontez-nous qui êtes-vous, de votre vous virtuel mais aussi de votre vous réel ! 😉</p>
                </span>
            </div>
            <BoutonNext link="/inscription-email"></BoutonNext>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import BoutonNext from "@/components/boutons/BoutonNext.vue";

export default {
    name: "inscription-histoire",
    components: {
        Header,
        BoutonNext
    }
};
</script>

<style scoped lang="scss">
.inscription {
    margin-top: 60px;
    height: 100%;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px;
        text-align: left;
    }
}

.open-book {
    p:first-of-type {
        text-indent: 0;
    }

    p:first-of-type:first-letter {
        float: left;
        font: 700 3em/0.65 "sunshiney", sans-serif;
        padding: 0.15em 0.15em 0 0;
        text-transform: uppercase;
    }
}
</style>